// extracted by mini-css-extract-plugin
export default {"invitation":"Invitation_invitation__eDzvR","names":"Invitation_names__YHjqx","date":"Invitation_date__E59KN","address":"Invitation_address__Jn-hv","bow":"Invitation_bow__K4yh5"};